import api from './api'

export const savingsService = {
  getTypes: () => {
    return api.get('/savings/types')
  },

  getAccounts: (nba) => {
    return api.get('/savings', { params: { nba } })
  },

  getAll: (params = {}) => {
    return api.get('/savings', { params })
  },

  getById: (noRekening) => {
    return api.get(`/savings/${noRekening}`)
  },

  create: (data) => {
    return api.post('/savings', data)
  },

  deposit: (noRekening, jumlah, keterangan = '') => {
    return api.post(`/savings/${noRekening}/deposit`, { jumlah, keterangan })
  },

  withdraw: (noRekening, jumlah, keterangan = '', sumberDana = 'kas') => {
    return api.post(`/savings/${noRekening}/withdraw`, { jumlah, keterangan, sumberDana })
  },

  getTransactions: (noRekening, params = {}) => {
    // Support both old signature (noRekening as string) and new signature (noRekening as object)
    if (typeof noRekening === 'string') {
      return api.get(`/savings/${noRekening}/transactions`, { params })
    }
    // If first param is object, treat as params only
    return api.get('/savings/transactions', { params: noRekening })
  },

  getByType: (jenis, params = {}) => {
    return api.get(`/savings`, { params: { ...params, jenis } })
  },

  getInterestRates: (jenis = 'SUKARELA') => {
    return api.get(`/savings/interest-rates`, { params: { jenis } })
  },

  transferOutstandingInterest: () => {
    return api.post('/savings/tutup-buku')
  }
}
